(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfp-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nfp-lookbook-mosaic')) {
    customElements.define('nfp-lookbook-mosaic', class extends HTMLElement {
      connectedCallback() {
        this.scheduleLayout = () => {
          cancelAnimationFrame(this.layoutFrame);
          this.layoutFrame = requestAnimationFrame(() => this.layoutPhotos());
        };
        if ('ResizeObserver' in window) {
          this.sizeObserver = new ResizeObserver(entries => {
            const width = entries[0].contentRect.width;
            if (Math.abs(width - (this.lastWidth || 0)) > 0.5) this.scheduleLayout();
          });
          this.sizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.scheduleLayout);
        }
        this.scheduleLayout();
      }
      layoutPhotos() {
        const width = this.getBoundingClientRect().width;
        if (width <= 0) return;
        const gap = parseFloat(getComputedStyle(this).rowGap) || 0;
        const rowHeight = 4;
        const photos = [...this.querySelectorAll('[data-photo-ratio]')];
        const spans = photos.map(photo => {
          const ratio = Number(photo.dataset.photoRatio) || 1;
          const height = photo.getBoundingClientRect().width / ratio;
          return Math.max(1, Math.ceil((height + gap) / (rowHeight + gap)));
        });
        photos.forEach((photo, index) => { photo.style.gridRowEnd = `span ${spans[index]}`; });
        this.setAttribute('data-ready', '');
        this.lastWidth = width;
      }
      disconnectedCallback() {
        this.sizeObserver?.disconnect();
        window.removeEventListener('resize', this.scheduleLayout);
        cancelAnimationFrame(this.layoutFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
